import { render } from "./ModeratorLayout.vue?vue&type=template&id=0d65c204&scoped=true&ts=true"
import script from "./ModeratorLayout.vue?vue&type=script&lang=ts"
export * from "./ModeratorLayout.vue?vue&type=script&lang=ts"

import "./ModeratorLayout.vue?vue&type=style&index=0&id=0d65c204&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d65c204"]])

export default __exports__